<template>
  <div class="tit-box">
    <span class="info1">시설명을 클릭하여 시설을 선택해주세요.</span>
  </div>
  <table class="tb-col">
    <colgroup>
      <col style="width:10%" />
      <col style="width:auto" />
      <col style="width:25%" />
      <col style="width:25%" />
    </colgroup>
    <thead>
    <tr>
      <th>번호</th>
      <th>시설명</th>
      <th>분류</th>
      <th class="last">사업자등록번호</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(fclty, index) in fcltys"
        :key="'fclty_' + fclty.fcltySn">
      <td>{{ index+1 }}</td>
      <td class="__left"
          @click="fcltyNm_click(fclty)">
        <a href="javascript:;">{{ fclty.fcltyNm }}</a>
      </td>
      <td>{{ fclty.fcltyTynm}}</td>
      <td class="last">{{ $cmmn.txt.getBznoFormat(fclty.bzno) }}</td>
    </tr>
    <tr v-if="fcltys.length == 0">
      <td class="last"
          colspan="4">선택가능한 시설이 존재하지 않습니다.</td>
    </tr>
    </tbody>
  </table>
</template>

<script setup>
import {onBeforeMount, ref, defineEmits} from "vue";
import {getUtils, getStore} from "@/utils/import";

const { $cmmn} = getUtils();
const {$mber, $loading} = getStore();

const fcltys = ref([]);
const getFcltysByMberSn = async () => {
  const getFcltysParams = {
    mberSn: $mber.mberSn,
    svcId: $cmmn.svc.getSeroiSvcId(),
  }

  fcltys.value = await $cmmn.fclty.getFcltysByMberSn(getFcltysParams);
}

const emits = defineEmits(['choc', 'close']);
const fcltyNm_click = ({fcltySn, fcltyNm}) => {
  emits('choc', {fcltySn, fcltyNm});
  emits('close');
}

onBeforeMount(async () => {
  try {
    $loading.on();

    await getFcltysByMberSn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
